import { Injectable } from '@angular/core';
import {
	IWorkflowAuthPayload,
	IWorkflowAuthResponse,
	IWorkflowDetailResponse,
	IWorkflowsCreatePayload,
	IWorkflowsCreateResponse,
	IWorkflowsListPayload,
	IWorkflowsListResponse,
} from '../models/workflows.models';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';

@Injectable({
	providedIn: 'root',
})
export class WorkflowsService extends ApiService {
	public list(body: IWorkflowsListPayload): Observable<IWorkflowsListResponse> {
		return this.http.post<IWorkflowsListResponse>(environment.apiUrl + `/profiles`, body, {
			headers: this.getHeaders(),
		});
	}

	public create(body: IWorkflowsCreatePayload): Observable<IWorkflowsCreateResponse> {
		return this.http.post<IWorkflowsCreateResponse>(environment.apiUrl + `/profile/create`, body, {
			headers: this.getHeaders(),
		});
	}

	public update(id: any, body: IWorkflowsCreatePayload): Observable<any> {
		return this.http.patch<any>(environment.apiUrl + `/profile/${id}`, body, {
			headers: this.getHeaders(),
		});
	}

	public detail(id: string): Observable<IWorkflowDetailResponse> {
		return this.http.get<IWorkflowDetailResponse>(environment.apiUrl + `/profile/${id}`, {
			headers: this.getHeaders(),
		});
	}

	public delete(id: string): Observable<any> {
		return this.http.delete<any>(environment.apiUrl + `/profile/${id}`, {
			headers: this.getHeaders(),
		});
	}

	public toggleStatus(id: string, status: 'active' | 'inactive'): Observable<any> {
		return this.http.patch<any>(
			environment.apiUrl + `/profile/${id}/status`,
			{ status },
			{
				headers: this.getHeaders(),
			},
		);
	}

	public duplicate(body: {
		profile_uuids: string[];
		api_key_uuid: string;
		design_config_uuid: string;
	}): Observable<{ profile_uuids: string[] }> {
		return this.http.post<{ profile_uuids: string[] }>(environment.apiUrl + `/profile/duplicate`, body, {
			headers: this.getHeaders(),
		});
	}

	public duplicateToEnv(body: {
		profile_uuid: string;
		target_env: 'current' | 'int' | 'pre' | 'pro';
	}): Observable<{
		profile_uuid: string;
		company_uuid?: string | null;
		target_env: string;
		mode: string;
		created?: Record<string, boolean>;
	}> {
		return this.http.post<{
			profile_uuid: string;
			company_uuid?: string | null;
			target_env: string;
			mode: string;
			created?: Record<string, boolean>;
		}>(environment.apiUrl + `/profile/duplicate-to-env`, body, {
			headers: this.getHeaders(),
		});
	}

	public createAuth(body: IWorkflowAuthPayload): Observable<IWorkflowAuthResponse> {
		return this.http.post<IWorkflowAuthResponse>(environment.pwcs + `/auth`, body, {
			headers: this.getPublicHeaders(),
		});
	}
}
